import { component as defineComponent } from 'flightjs';

function UserSwitcher() {

    this.defaultAttrs({
        radioSelector : 'input[type=radio][name=userid]'
    });

    this.after('initialize', function() {
        this.on(
            this.$node.select('radioSelector'),
            'change',
            this.submitForm
        );
    });

    this.submitForm = function() {
        const $form = this.$node.closest('form');

        if (!this.$node.find('input[name="from"]').length) {
            $('<input>')
                .attr({
                    type: 'hidden',
                    name: 'from'
                })
                .val(this.getFromUrl())
                .appendTo($form);
        }

        $form.submit();
    };

    this.getFromUrl = function() {
        return window.location.href;
    }
}

export default defineComponent(UserSwitcher);



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/lib/ui/user-switcher.js